import React from 'react';
import { useSelector } from 'react-redux';
import DealerInfoBlock from './DealerInfoBlock';
import ContactList from './ContactList';

/**
 * DealerContactSection — orchestrator.
 * Reads dealerInfo from Redux and delegates rendering to sub-components.
 * Returns null when there is no data to display (no departments and no map query).
 */
const DealerContactSection = () => {
	const {
		accountName = null,
		addressLine1 = null,
		addressLine2 = null,
		mapsQuery = null,
		departments = [],
		accountId = null
	} = useSelector((state) => state.dealerInfo ?? {});

	if (!departments.length && !mapsQuery) {
		return null;
	}

	const showDealerInfo = accountName || addressLine1 || addressLine2;

	return (
		<div
			className="ws-nav-drawer__dealer-contact"
			data-testid="dealer-contact-section"
		>
			{showDealerInfo && (
				<DealerInfoBlock
					accountName={accountName}
					addressLine1={addressLine1}
					addressLine2={addressLine2}
				/>
			)}
			<ContactList
				departments={departments}
				mapsQuery={mapsQuery}
				accountId={accountId}
			/>
		</div>
	);
};

export default DealerContactSection;
